import $ from 'jquery'
import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as FPT from '../../utility/fpt'
import AppStore from '../../stores/AppStore'
import templateData, { localsMessages } from '../../utility/getTemplateData'

class PaymentError extends React.Component {
	constructor() {
		super();
		this.state = {}
	}

	componentDidMount = () => {
		$('.spinneroverlay').hide()
		const ERROR_CODE = AppStore.getPaymentError() || ''
		FPT.trackPage('main:donate:wps:guest:failure', 'main:donate:wps:guest:failure:web::', 'ERROR_CODE', ERROR_CODE)
	}

	handleTryAgain = () => {
        this.context.router.push(`/donate?token=${templateData.token}`)
	}

	render() {

        const { error = {}, label = {} } = localsMessages('errors/paymentError');
        const ERROR_CODE = AppStore.getPaymentError() || '';

        let { WSM_CANNOT_PAY_SELF = '', WENT_WRONG, TEMP_GLITCH } = error;
        let { tryagain } = label;

        switch (ERROR_CODE) {
            case 'WSM_PAYMENT_DENIED':
                WENT_WRONG = error.DID_NOT_WORK;
                TEMP_GLITCH = error.DIFF_CREDIT_DEBIT;
                tryagain = label.trydiffcard;
                break;
            case 'WSM_CANNOT_PAY_SELF':
                const L2 = WSM_CANNOT_PAY_SELF && WSM_CANNOT_PAY_SELF.replace('{data.dataMerchant.name}', templateData.donationName);
                WENT_WRONG = error.WSM_CANNOT_PAY_SELF_H;
                TEMP_GLITCH = L2;
                break;
            default:
                break;
        }

		return (
			<div className="donate_wrapper">
				<div className="container">
					<div className="col-xs-12 col-sm-12 col-md-12 text-center">
						<div className="error_page_landing">
							<h1 className="text-center"><span className="icon icon-large icon-attention-large" aria-hidden="true"></span></h1>
							<p className="error_message1">{WENT_WRONG}</p>
							<div className="error_message2">
								<p>{TEMP_GLITCH}</p>
							</div>
							<div style={{ maxWidth: 360, margin: '50px auto 0px' }}>
								<button type="button"
									className="vx_btn vx_btn-block"
									onClick={this.handleTryAgain} >
									{tryagain}
								</button>
							</div>
	                    </div>
	                </div>
	            </div>
	        </div>
        )
    }
}

PaymentError.contextTypes = {
    router: PropTypes.object.isRequired
};

export default PaymentError



// WEBPACK FOOTER //
// ./pages/error/paymentError.js